import { useDispatch, useSelector } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import classNames from 'classnames'
import { Button } from '../../../../../Components'
import { selectClientIsGuest } from '../../../../../store/selectors/client'
import { toggleAuthModal } from '../../../../../actions/homeSearchAuthModal'
import styles from './DesktopAuthButtons.module.scss'

export const DesktopAuthButtons = () => {
  const dispatch = useDispatch()
  const isGuest = useSelector(selectClientIsGuest)

  const handleOnClick = () => {
    dispatch(toggleAuthModal(true))
  }

  if (!isGuest) return <div />

  return (
    <div className={styles.btnGroup}>
      <Button
        primary
        id='signUpBtn'
        className={styles.btn}
        onClick={handleOnClick}
      >
        <FormattedMessage
          data-qa='signUpBtn'
          id='Navbar.signUp.cta'
          defaultMessage='Sign up'
        />
      </Button>
      <Button
        id='loginBtn'
        className={classNames(styles.btn, styles.minimal)}
        onClick={handleOnClick}
      >
        <FormattedMessage
          data-qa='loginBtn'
          id='Navbar.logIn.cta'
          defaultMessage='Log in'
        />
      </Button>
    </div>
  )
}
